import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ClessonResult } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { CriteriaMark } from '@yandex-int/k-common/client/api/defs/get-criteria-marks';

import { ClessonResultsStoreState } from './typings';

const initialState: ClessonResultsStoreState = {
    items: {},
    criteriaMarks: {},
};

const clessonResultInitialState = {
    loadingStatus: LOADING_STATUSES.UNSENT,
    data: null,
};

// экшны нужны для саги
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function */
const slice = createSlice({
    name: 'CLESSONS_RESULTS',
    initialState: initialState,
    reducers: {
        getClessonsResultsRequest: (
            state: ClessonResultsStoreState,
            action: PayloadAction<{ clessonIds: number[] }>
        ) => {
            const { clessonIds } = action.payload;
            clessonIds.forEach((id) => {
                if (!state.items[id]) {
                    state.items[id] = { ...clessonResultInitialState };
                }

                state.items[id].loadingStatus = LOADING_STATUSES.LOADING;
            });
        },

        getClessonsResultsSuccess: (
            state: ClessonResultsStoreState,
            action: PayloadAction<{ clessonResults: ClessonResult[]; criteriaMarks: CriteriaMark[] }>
        ) => {
            const { clessonResults, criteriaMarks } = action.payload;

            clessonResults.forEach((clessonResult) => {
                const id = clessonResult.clesson_id;
                if (!state.items[id]) {
                    state.items[id] = { ...clessonResultInitialState };
                }

                state.items[id].loadingStatus = LOADING_STATUSES.SUCCESS;
                state.items[id].data = clessonResult;
            });

            Object.assign(state.criteriaMarks, criteriaMarks);
        },

        getClessonsResultsError: (state: ClessonResultsStoreState, action: PayloadAction<{ clessonIds: number[] }>) => {
            const { clessonIds } = action.payload;

            clessonIds.forEach((clessonId) => {
                if (!state.items[clessonId]) {
                    state.items[clessonId] = { ...clessonResultInitialState };
                }

                state.items[clessonId].loadingStatus = LOADING_STATUSES.ERROR;
            });
        },
    },
});
/* eslint-enable @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function */

export const clessonResultsActions = slice.actions;
export const clessonResultsReducer = slice.reducer;
